import { TextColor } from '../../types';
import { BackButton, Typography, TypographyType } from '../shared';
import SidebarFooter from './SidebarFooter';

interface SidebarContentProps {
  content: React.ReactNode;
  title: string;
  showBackButton?: boolean;
}

const SidebarContent = ({ content, title, showBackButton }: SidebarContentProps) => {
  return (
    <div className="flex h-full w-full flex-col">
      <div className="flex h-full flex-col gap-6 overflow-y-hidden">
        {showBackButton && <BackButton />}
        <Typography color={TextColor.SECONDARY} type={TypographyType.LABEL}>
          {title}
        </Typography>
        {content}
      </div>
      <SidebarFooter />
    </div>
  );
};

export default SidebarContent;
